export const DBN_AGENTS_RESET_STATE = 'DBN_AGENTS_RESET_STATE';
export const DBN_AGENTS_CURRENT_ITEM = 'DBN_AGENTS_CURRENT_ITEM';

export const DBN_AGENTS_REQUEST_LOADING = 'DBN_AGENTS_REQUEST_LOADING';
export const DBN_AGENTS_REQUEST_SUCCESS = 'DBN_AGENTS_REQUEST_SUCCESS';
export const DBN_AGENTS_REQUEST_FAILED = 'DBN_AGENTS_REQUEST_FAILED';

export const DBN_AGENTS_CURRENT_ACTION = 'DBN_AGENTS_CURRENT_ACTION';
export const DBN_AGENTS_RESET_ACTION = 'DBN_AGENTS_RESET_ACTION';